import { FaCheck, FaTimes } from "react-icons/fa";

const ImageValidationCard = ({ item, statusClass }) => {
    return (
        <div className={`dropzone-preview relative cursor-default w-full max-w-[430px] rounded-md border p-2 ${statusClass(item.status)}`}>
            {item.flash && (
                <div
                    className={`
                        absolute inset-0 flex items-center justify-center pointer-events-none
                        transition-all duration-300 ease-out
                        ${item.flashVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}
                    `}
                >
                    <div className="relative h-14 w-14 rounded-full bg-zinc-100/90 border border-zinc-300 shadow-sm flex items-center justify-center">
                        <div className="absolute top-2 left-2 h-5 w-7 rounded-full bg-white/70 blur-[0.5px]" />
                        {item.flash === "success" ? (
                            <FaCheck className="text-[26px] text-zinc-400 drop-shadow-[0_1px_0_rgba(255,255,255,0.7)]" />
                        ) : (
                            <FaTimes className="text-[26px] text-zinc-400 drop-shadow-[0_1px_0_rgba(255,255,255,0.7)]" />
                        )}
                    </div>
                </div>
            )}
            
            <div className="flex w-full h-full items-center">
                {/* fotenha */}
                <div className="w-[120px] shrink-0 flex items-center justify-center pt-1">
                    <div 
                        className="h-[120px] w-[120px] rounded bg-center bg-cover border border-zinc-300" 
                        style={{ backgroundImage: `url(${item.url})` }}
                    />
                </div>
                {/* tab */}
                <div className="flex-1 min-w-0 flex items-start">
                    {item.status === "valid" && item.info && (
                        <table className="w-full text-xs border-collapse">
                            <tbody className="
                                [&>tr:nth-child(odd)]:bg-zinc-200 
                                [&>tr:nth-child(even)]:bg-white 
                                text-zinc-500 [&>tr]:cursor-default 
                                 /* sem cursor de clique */
                                [&_*]:!cursor-default
                                [&>tr:hover]:!bg-transparent
                                [&>tr:hover]:!text-zinc-500
                                [&>tr:hover>td]:!bg-transparent
                                [&>tr:hover>td]:!text-zinc-500
                                [&>tr:nth-child(odd):hover]:!bg-zinc-200
                                [&>tr:nth-child(even):hover]:!bg-white
                            ">
                                <tr>
                                    <td className="py-1 px-2 font-semibold align-center text-xs!">ID do Usuário</td>
                                    <td className="py-1 px-2 text-left break-words text-xs!">{item.info.user_id}</td>
                                </tr>
                                <tr>
                                    <td className="py-1 px-2 font-semibold align-center text-xs!">Nome do Usuário</td>
                                    <td className="py-1 px-2 text-left break-words text-xs!">{item.info.user_name}</td>
                                </tr>
                                <tr>
                                    <td className="py-1 px-2 font-semibold align-center text-xs!">Município</td>
                                    <td className="py-1 px-2 text-left break-words text-xs!">{item.info.city}</td>
                                </tr>
                                <tr>
                                    <td className="py-1 px-2 font-semibold align-center text-xs!">Entidade</td>
                                    <td className="py-1 px-2 text-left break-words text-xs!">{item.info.entity}</td>
                                </tr>
                                <tr>
                                    <td className="py-1 px-2 font-semibold align-center text-xs!">Data de Exportação</td>
                                    <td className="py-1 px-2 text-left break-words text-xs!">{item.info.export_date}</td>
                                </tr>
                                <tr>
                                    <td className="py-1 px-2 font-semibold align-center text-xs!">ID da Passagem</td>
                                    <td className="py-1 px-2 text-left break-words text-xs!">{item.info.procid}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    {item.status === "invalid" && (
                        <div className="w-full flex items-center justify-center">
                            <div className="text-center text-base font-bold text-zinc-800 leading-snug">
                                A imagem não pode ser validada
                            </div>
                        </div>
                    )}
                    {item.status === "error" && (
                        <div className="w-full flex items-center justify-center">
                            <div className="text-center text-lg font-bold text-red-800">
                                {item.error ?? "Não foi possível validar a imagem."}
                            </div>
                        </div>
                    )}

                    {item.status === "validating" && (
                        <div className="w-full flex items-center justify-center">
                            <div className="w-20 h-4 rounded-full bg-zinc-200 overflow-hidden">
                                <div className="h-full rounded-full bg-zinc-500 transition-[width] duration-200" style={{ width: `${item.progress ?? 0}%` }} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
};

export default ImageValidationCard;